import apiClient from "./client.js";
import { API_URLS } from "./urls.js";
// Get all agents
export const getScoringConfig = () =>
  apiClient.get(API_URLS.AGENTS.SCORING_CONFIG).then((res) => res.data);

// Create scoring
export const createScoringConfig = (id, data) =>
  apiClient
    .post(API_URLS.AGENTS.SCORING_CONFIG(id), data)
    .then((res) => res.data);

// Update scoring
export const updateScoringConfig = (id, data) =>
  apiClient
    .patch(API_URLS.AGENTS.SCORING_CONFIG(id), data)
    .then((res) => res.data);

// Delete agent
export const deleteScoringConfig = (id) =>
  apiClient.delete(API_URLS.AGENTS.SCORING_CONFIG(id)).then((res) => res.data);
